import { BugsnagErrorBoundary } from '@bugsnag/plugin-react'
import { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'

import axios from 'utils/axios'
import { getCookie } from 'utils/cookies'

import ErrorFallback from 'components/ErrorFallback'
import Routes from 'components/Routes'
import ScrollToTop from 'components/layout/ScrollToTop'
import { useAttributionCapture } from 'hooks/useAttributionCapture'

export interface AppRootProps {
  ErrorBoundary?: BugsnagErrorBoundary
}

export default function AppRoot({ ErrorBoundary }: AppRootProps): JSX.Element {
  // Which link and channel brought this visitor (ref / ch / utm tags), kept
  // for the sign-up (utils/attribution.ts).
  useAttributionCapture()

  axios.interceptors.request.use(
    (request: InternalAxiosRequestConfig) => {
      if (
        request.method !== 'GET' &&
        request.url !== `${process.env.REACT_APP_GOLDIE_REST_ENDPOINT}/login`
      ) {
        request.headers.set('X-CSRF-Token', getCookie('CSRF-TOKEN') ?? '')
      }

      return request
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )

  return (
    <ScrollToTop>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        {ErrorBoundary ? (
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Routes />
          </ErrorBoundary>
        ) : (
          <Routes />
        )}
      </QueryParamProvider>
    </ScrollToTop>
  )
}
